export default __webpack_public_path__ + "static/media/faq2.503b5f2e.jpg";